import React from "react";

const FeaturesSection = () => {
  return (
    <>
      <section
        className="services-section text-center pt-125 rpt-95"
        id="services"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8 col-md-10">
              <div className="section-title mb-50">
                <span className="sub-title">Powerful Features</span>
                <h2>Transform Your Design Workflow with AI</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <div className="service-item wow fadeInUp delay-0-2s">
                <img src="assets/images/services/icon-1.png" alt="Icon" />
                <h4>Lightning-Fast Conversion</h4>
                <p>
                  Transform complex UI/UX designs into clean, production-ready
                  code in seconds, not hours. Our advanced AI processes your
                  files instantly with pixel-perfect accuracy.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="service-item wow fadeInUp delay-0-4s">
                <img src="assets/images/services/icon-2.png" alt="Icon" />
                <h4>Multi-Framework Support</h4>
                <p>
                  Generate code in your preferred framework - Tailwind CSS,
                  Bootstrap, or plain CSS. Our AI adapts to your tech stack and
                  coding standards seamlessly.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="service-item wow fadeInUp delay-0-6s">
                <img src="assets/images/services/icon-3.png" alt="Icon" />
                <h4>Responsive & Production-Ready</h4>
                <p>
                  Get clean, maintainable code that's fully responsive and
                  optimized for performance. No more manual adjustments - deploy
                  directly to production.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeaturesSection;
